import { lazy } from '@/service/lazy'

export default [{
  name: 'Usuarios',
  path: 'usuarios',
  id: 'usuarios',
  icon: 'fa fa-user',
  component: lazy('app/default/gerenciador/usuario/index'),
  meta: { requireAuth: true, rules: ['gerenciar_usuario'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/usuario.js